import React from 'react';
import { Link } from 'gatsby';

import LaserBeamsIcon from '@images/icons/laser-beams.svg';
import GPSIcon from '@images/icons/gps.svg';
import PhoneBluetoothIcon from '@images/icons/phone-bluetooth.svg';
import SoundWaveIcon from '@images/icons/soundwave.svg';
import ThermalSensorsIcon from '@images/icons/thermal-sensors.svg';
import SquaredSmileyFaceIcon from '@images/icons/squared-smiley-face.svg';
import EmptyBoxIcon from '@images/icons/empty-box.svg';
import CameraIcon from '@images/icons/camera.svg';

import GPSTechIcon from '@images/icons/technologies/gps.svg';
import BluetoothIcon from '@images/icons/technologies/ble.svg';
import WiFiIcon from '@images/icons/technologies/wifi.svg';
import NFCIcon from '@images/icons/technologies/nfc.svg';
import RFIDIcon from '@images/icons/technologies/rfid.svg';
import UWBIcon from '@images/icons/technologies/uwb.svg';
import AirTagIcon from '@images/icons/technologies/air-tag.svg';

import SprintIcon from '@images/icons/sprint.svg';
import TestingIcon from '@static/images/icons/testing-icon.svg';
import CustomSoftwareIcon from '@static/images/icons/development-icon.svg';

import { PageUrls } from '@utils/constants/PageUrls';

export const SPARK_YOUTUBE_VIDEO = 'https://www.youtube.com/embed/zZ6MMdLUMBs';

export const footFallFeatures = [
	{
		title: 'Tools against COVID-19',
		description:
			'every solution that measures people could be used for detection of the unusual crowd and dangerous zones',
	},
	{
		title: 'Safety',
		description:
			'airports, government buildings - places that could not be crowded',
	},
	{
		title: 'Marketing',
		description: 'shops, markets',
	},
	{
		title: 'Analysis',
		description: 'count how many people attend in your events',
	},
	{
		title: 'Business development',
		description:
			'predict how your business will grow thanks to custom analysis',
	},
];

export const HowToMeasurePeopleItems = [
	{
		title: 'Laser Beams Footfall Analitycs',
		icon: LaserBeamsIcon,
		content: (
			<p>
				a beam across the store’s door counts each time the customers when they
				cross the threshold.
			</p>
		),
	},
	{
		title: 'WiFi Footfall Analytics',
		icon: SquaredSmileyFaceIcon,
		content: (
			<p>
				measure your unique and repeat visitors and track customers as they move
				around the store. Record the crowd volume who walk past your store
				without entering and your bounce rate.
			</p>
		),
	},
	{
		title: 'Bluetooth Footfall Analytics',
		icon: PhoneBluetoothIcon,
		content: (
			<p>
				the technology based on beacons. Smartphone apps can receive beacon
				signals and interpret them, expanding the user’s context.
			</p>
		),
	},
	{
		title: 'GPS Mobile Location Analytics',
		icon: GPSIcon,
		content: (
			<p>
				geolocation uses mobile devices built-in GPS to accurately show where
				the device, and the user of the device, are located.
			</p>
		),
	},
	{
		title: 'Camera-Based Footfall Analytics',
		icon: CameraIcon,
		content: (
			<p>
				thanks to 3D imaging, modern facial cameras can not only count the
				visitors to your store but also determine other metrics such as gender
				and age.
			</p>
		),
	},
	{
		title: 'Thermal Imaging Sensors',
		icon: ThermalSensorsIcon,
		content: (
			<p>
				the technology measures foot traffic by picking up the heat signatures
				of people as they enter or exit a particular area.
			</p>
		),
	},
	{
		title: 'BTS tracking',
		icon: SoundWaveIcon,
		content: <p>radio environment activity.</p>,
	},
	{
		title: 'And others',
		icon: EmptyBoxIcon,
		content: (
			<div>
				<p>You want to know more?</p>
				<Link className="bttn bttn-orange-border mt-2 link" to="/contact">
					Contact Us
				</Link>
			</div>
		),
	},
];

export const technologies = [
	{ icon: GPSTechIcon, name: 'GPS' },
	{ icon: BluetoothIcon, name: 'BLE' },
	{ icon: UWBIcon, name: 'UWB' },
	{ icon: AirTagIcon, name: 'AirTag' },
	{ icon: WiFiIcon, name: 'WiFi' },
	{ icon: RFIDIcon, name: 'RFID' },
	{ icon: NFCIcon, name: 'NFC' },
];

export const canBeAppliedForData = [
	'positioning systems for tracking your products',
	'supply chain tracker in transportation',
	'indoor asset tracking',
	'outdoor asset tracking',
];

export const internalLinkingData = [
	{
		icon: SprintIcon,
		title: 'How we work?',
		items: ['Development Flow', 'Weekly Sprints', 'Communication'],
		link: PageUrls.HOW_WE_WORK,
	},
	{
		icon: TestingIcon,
		title: 'Quality Assurance & Testing',
		items: ['Manual testing', 'Automated testing', 'Unit testing'],
		link: PageUrls.TESTING,
	},
	{
		icon: CustomSoftwareIcon,
		title: 'Custom Software Development',
		items: [
			{ title: 'Web Applications', subItems: ['Frontend', 'Backend'] },
			{ title: 'Mobile Applications', subItems: ['Native', 'Cross-platform'] },
		],
		link: PageUrls.DEVELOPMENT,
	},
];
